import HttpRequest from '@/service/axios'
 //const baseUrl = "https://shopmall.azurewebsites.net";
// const baseUrl = "http://localhost:57993"
const baseUrl = "https://cgpwebec.azurewebsites.net"
const merchantId = "alive.cgpmall.com";
const axios = new HttpRequest(baseUrl)
const crytpoLowLimit = { 'ETH': 0.03, 'BTC': 0.0008, 'USDT': 8 };
const siteName ="o血拼"
export {axios, merchantId,baseUrl,crytpoLowLimit,siteName}